import PageHeader from '@/components/widgets/PageHeader/PageHeader.vue';

// @vue/component
export default {
  name: 'GDPRConsent',
  components: {
    PageHeader,
  },
};



// WEBPACK FOOTER //
// ./src/components/sections/GDPRConsent/GDPRConsent.js